import { I18nProvider } from "@heroui/react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import { PersistGate } from "redux-persist/integration/react";
import { AuthBootstrap } from "./auth/components/auth-bootstrap";
import { ConfirmDialogProvider } from "./common/contexts/confirm-dialog-provider";
import { AppThemeProvider } from "./common/contexts/theme-provider";
import { rootRouter } from "./common/navigations/root-router";
import { persistor, store } from "./common/redux/store";

export function App() {
	return (
		<HelmetProvider>
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<AppThemeProvider>
						<I18nProvider locale="fr-FR">
							<ConfirmDialogProvider>
								<AuthBootstrap />
								<RouterProvider router={rootRouter} />
							</ConfirmDialogProvider>
						</I18nProvider>
					</AppThemeProvider>
				</PersistGate>
			</Provider>
		</HelmetProvider>
	);
}
